import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '@src/environments/environment';

import { Message } from '../interfaces/message';
import { EmailValidator } from '@angular/forms';

import { supaConfig } from '@src/config/supabase.config';

@Injectable({
  providedIn: 'root'
})

export class MessageService {
  constructor(
    private http: HttpClient
  ) { }

  private handleError<T>(data?: any) {
    return (error: any): Observable<T> => {
      if (error.status === 0 || error.status === 500) {
        console.error('An error occurred:', error.error);
      } else {
        console.error(`A backend error occurred, returned code ${error.status}. Body was: `, error.error);
      }

      return of(error as T);
    };
  }

  sendMessage(body: Message): Observable<any> {
    const url = environment.contactURL,
    
          headers = new HttpHeaders({
            'Content-Type': ' text/plain',
            'Access-Control-Allow-Origin': '*'
          });

    return this.http.post(
      url, 
      JSON.stringify(body),
      { headers }
    )
    .pipe(
      catchError(this.handleError<any>(body))
    )
  }

  subscribeUser(email: EmailValidator, data?: object): Observable<any> {
    if (!email)
      return new Observable(() => undefined);

    if (data)
      Object.assign(data, { 'email': email })
    
    const url = supaConfig.contactsURL + '?on_conflict=email',
          headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'apiKey': supaConfig.apiKey,
            'Prefer': 'resolution=merge-duplicates,return=representation'
          });

    return this.http.post(
      url, 
      JSON.stringify([
        data || {
          'email': email,
          'source': 'blog_nl_banner',
          'subscribed': true
        }
      ]),
      { headers },
    )
    .pipe(
      catchError(this.handleError<any>())
    )
  }
}
